<template>
  <b-modal :id="`submit-generate-docx-${row.id}`" :title="$translate('GENERATE DOCX')" hide-footer centered content-class="rounded-8">
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <h5>
          {{ 'Are you sure that you want to generate docx file?' | i18n }}
        </h5>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between mt-3">
        <b-button variant="outline-secondary" size="lg" class="btn-delete-device mr-3 px-75" @click="onClose">
          {{ 'no' | i18n }}
        </b-button>
        <b-button
          variant="outline-primary"
          size="lg"
          :class="`btn-delete-device px-${isGeneratingDocx ? '35' : '75'}`"
          :disabled="isGeneratingDocx"
          @click="generateDocx"
        >
          {{ isGeneratingDocx ? $translate('Generating') : $translate('yes') }}
          <b-spinner v-if="isGeneratingDocx" class="ml-1" small />
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { ReportsMixin, NotificationMixin } from '../../../../mixins';
import { DOCX_CONVERT_ERROR } from '../../../../../../../constants';

export default {
  name: 'GenerateDocxReport',
  mixins: [ReportsMixin, NotificationMixin],
  props: {
    download: {
      type: Function,
      default: () => {},
    },
    row: {
      type: Object,
      default: () => {},
    },
    reports: {
      type: Array,
      default: () => [],
    },
    setReports: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      isGeneratingDocx: false,
      intervalIndex: null,
    };
  },
  methods: {
    async generateDocx() {
      try {
        this.isGeneratingDocx = true;
        await this.reportsService.generateDocx(this.row.id);
        this.intervalIndex = setInterval(async () => {
          const res = await this.reportsService.getReportById(this.row.id);
          if (res.data.docx) {
            clearInterval(this.intervalIndex);
            if (res.data.docx === DOCX_CONVERT_ERROR) {
              this.showNotification({ type: 'error', message: this.$translate('Convert error occurred') });
              this.isGeneratingDocx = false;
              return;
            }
            const reportIndex = this.reports.findIndex(({ id }) => id === this.row.id);
            const updatedReports = [...this.reports];
            updatedReports.splice(reportIndex, 1, { ...this.reports[reportIndex], docx: res.data.docx });
            this.setReports(updatedReports);
            this.download(this.row.id, 'docx');
            this.$root.$emit('bv::hide::modal', `submit-generate-docx-${this.row.id}`);
            this.isGeneratingDocx = false;
          }
        }, 1500);
      } catch (error) {
        this.showNotification({ type: 'error', message: this.$translate(error.message) });
        this.isGeneratingDocx = false;
      }
    },
    onClose() {
      this.$root.$emit('bv::hide::modal', `submit-generate-docx-${this.row.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}
.px-35 {
  padding-left: 35px;
  padding-right: 35px;
}
.px-75 {
  padding-left: 75px;
  padding-right: 75px;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
